/**
 * Gatherings page
 */
function irGatheringsPage() {
	if (!document.querySelector('main.subpage.ir-page.gatherings')) return;

	$('.gatherings-nav').on('change', function() {
		const selectedYear = $(this).val();
		$('.gatherings-events .events').hide();
		$('.events[data-year="' + selectedYear + '"]').fadeIn();
	});

}
